<script lang="ts">
  import { Col, Form, Row } from "sveltestrap";
  import { BuyingOption, DeliveryOption, VerticalMessage, VerticalStyle } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import VerticalDelivery from "./VerticalDelivery.svelte";
  import FormFooter from "./FormFooter.svelte";
  import VerticalBuying from "./VerticalBuying.svelte";
</script>
<Col sm="12" xl="6">
  <Card cardProps="height-equal" cardBodyprops="megaoptions-border-space-sm" headerTitle={VerticalStyle} cardHeaderprops="pb-0">
    <div slot="customheader">
      <span>{@html VerticalMessage}</span>
    </div>
    <div slot="contentbody">
      <Form class="mega-vertical">
        <Row>
          <Col sm="12">
              <p class="mega-title m-b-5">{DeliveryOption}</p>
          </Col>
          <VerticalDelivery />
          <Col sm="12">
              <p class="mega-title m-b-5">{BuyingOption}</p>
          </Col>
          <VerticalBuying />
        </Row>
      </Form>
    </div>
    <div slot="contentfooter">
      <FormFooter />
    </div>
  </Card>
</Col>